import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[580px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Ancient%20Chinese%20landscape%20with%20misty%20mountains%2C%20traditional%20ink%20wash%20painting%20style%2C%20serene%20atmosphere%2C%20soft%20golden%20light%2C%20ethereal%20clouds%2C%20classical%20Chinese%20aesthetic%2C%20elegant%20composition%2C%20warm%20earthy%20tones%2C%20scholarly%20atmosphere&width=1920&height=960&seq=hero-bg-2026&orientation=landscape"
        alt="黄游下戟 - 中国古代文化经典意象"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/30 to-black/45"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <p className="text-accent-300 font-medium text-sm md:text-base tracking-widest mb-4 font-label">
            中国古代经典文化意象
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-background-50 mb-6 leading-tight">
            黄游下戟
          </h1>
          <p className="text-background-50/80 text-base md:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            穿越千年时光，探寻中国古代典故的文化密码。从典籍考据到诗词传承，全面解析黄游下戟的出处、背景、寓意与当代价值。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/chuchu"
              className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap"
            >
              探索典故
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-background-50/40 hover:border-background-50 text-background-50 rounded-full font-medium text-sm transition-all duration-300 whitespace-nowrap"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex items-center gap-8 z-10">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="flex flex-col items-center gap-1 text-background-50/70 hover:text-background-50 transition-colors duration-200 group"
          >
            <div className="w-10 h-10 flex items-center justify-center rounded-full bg-background-50/10 group-hover:bg-background-50/20 transition-colors">
              <i className={`${cat.icon} text-sm`}></i>
            </div>
            <span className="text-xs whitespace-nowrap">{cat.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}